import { connect } from 'react-redux';
import { getInputDataToSend, getPosts } from '../../../../store/form/selectors';
import { fetchProductsData } from '../../../../store/products/actions';
import { fetchProductsBySection, setInputDataToSend } from '../../../../store/form/actions';
import PostSection from './PostSection';
import { getValidation } from '../../../../store/validation/selectors';
import { getLoader } from '../../../../store/loader/selectors';

const mapStateToProps = (state) => ({
  loader: getLoader(state),
  posts: getPosts(state),
  inputData: getInputDataToSend(state),
  validation: getValidation(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchProductsData: () => dispatch(fetchProductsData()),
  fetchProductsBySection: (
    section,
    panelGroup,
    postGroup,
    accessoryGroup,
    color,
    type,
    height,
  ) => {
    dispatch(fetchProductsBySection(
      section,
      panelGroup,
      postGroup,
      accessoryGroup,
      color,
      type,
      height,
    ));
  },
  setInputDataToSend: (key, data) => {
    dispatch(setInputDataToSend(key, data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PostSection);
